import React from 'react';
import ReactDOM from 'react-dom';
import { HashRouter as Router } from 'react-router-dom';

import reportWebVitals from './reportWebVitals';
import { ProvideAuth } from './Hooks/authHook';
import { ProvideAddress } from './Hooks/addressHook';
import './i18nextInit';
import StyledApp from './StyledApp';
import GuiErrorOutput from './components/GuiErrorOutput';

ReactDOM.render(
  <React.StrictMode>
    <GuiErrorOutput>
      <ProvideAddress>
        <ProvideAuth>
          <Router>
            <StyledApp />
          </Router>
        </ProvideAuth>
      </ProvideAddress>
    </GuiErrorOutput>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
